module.exports = __webpack_public_path__ + "static/media/icons8-firebase.1da8d950.svg";